import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { ListItem as ListItem$1 } from '@vds/core';

const ListItem = (_a) => {
    var { size = 'large', surface, color = 'primary' } = _a, rest = __rest(_a, ["size", "surface", "color"]);
    const getItemColor = () => {
        switch (color) {
            case 'primary':
                return `var(--vds-color-element-primary-on${surface === null || surface === void 0 ? void 0 : surface.toLowerCase()})`;
            case 'secondary':
                return `var(--vds-color-element-secondary-on${surface === null || surface === void 0 ? void 0 : surface.toLowerCase()})`;
            default:
                return color;
        }
    };
    return jsx(ListItem$1, Object.assign({ size: size }, rest, { color: getItemColor() }));
};

export { ListItem as default };
